import { useCallback } from 'react';

import style from './style.module.less';
import { TagSearchableDropdown } from '../../../../../../../../components/tag-dropdown/tag-searchable-dropdown';
import { INT_PARAMETER } from '../../../../../constants/parameter-name-for-update';

/**
 * @typedef {import('../../../../../types/automation-rule-types.d.ts').AutomationRuleActionInputValueProps} AutomationRuleActionInputValueProps
 */

/**
 * @param {object} props
 * @param {AutomationRuleActionInputValueProps} props.inputValueProps
 * @param {(updatedProps: AutomationRuleActionInputValueProps) => void} props.onChange
 * @param {ReactNode} props.label
 * @returns {JSX.Element}
 */
const AddTag = ({ onChange, inputValueProps, label }) => {
  const { intParameter } = inputValueProps;

  const updateTag = useCallback(
    (tagId) => {
      onChange({
        [INT_PARAMETER]: Number.parseInt(tagId, 10),
      });
    },
    [onChange],
  );

  return (
    <div className={style['multi-control-row']}>
      <div>{label}</div>
      <TagSearchableDropdown onChange={updateTag} value={intParameter?.toString()} />
    </div>
  );
};

export default AddTag;
